import { gql } from '@apollo/client'

export default gql`
  query topTrucksQuery($slug: String!) {
    marketBySlug(slug: $slug) {
      id
      name
      latitude
      longitude
      description {
        html
      }
      state
      stateFull
      image {
        original
        medium
      }
      topTrucksEnabled
      customerTopTrucksPath
      topTrucksDescription {
        html
      }
      marketTopTrucks {
        id
        description {
          html
        }
        position
        featuredItems {
          id
          name
          image {
            medium
          }
          description
        }
        truck {
          id
          name
          schedulePath
          menus {
            id
            foodTypes {
              id
              name
            }
          }
          image {
            medium
            high
          }
        }
      }
    }
    structuredData {
      marketTopTrucksPage(seoName: $slug)
    }
  }
`
